module.exports = __webpack_public_path__ + "img/logo.16e0e7f8.png";